import type { HTMLAttributes } from 'react';
import { cn } from './utils';

const PADDING_STYLES: Record<'md' | 'lg', string> = {
  lg: 'p-6',
  md: 'p-5',
};

type CardProps = HTMLAttributes<HTMLDivElement | HTMLElement> & {
  padding?: 'md' | 'lg';
  as?: 'div' | 'section';
};

/**
 * Instrument card — 12px corners, 1px hairline, `shadow-sm` and nothing
 * more (DESIGN.md's card spec). `lg` (24px padding) is the default content
 * card; `md` (20px) is for denser stat cards.
 */
export function Card({ padding = 'lg', as: Component = 'div', className, ...props }: CardProps) {
  return (
    <Component
      className={cn(
        'rounded-xl border border-border bg-card shadow-sm',
        PADDING_STYLES[padding],
        className,
      )}
      {...props}
    />
  );
}
